import { useCallback } from 'react';
import { APP_CONFIG } from '../config/settings';

export function useSlideshowTiming() {
  const calculateSlideDuration = useCallback((questionText: string, answers: string[]): number => {
    // Count total words in question and answers
    const questionWords = questionText.split(' ').length;
    const answerWords = answers.reduce((acc, answer) => acc + answer.split(' ').length, 0);
    const totalWords = questionWords + answerWords;

    // Base duration in milliseconds
    let duration = APP_CONFIG.RESULTS_BASE_DURATION * 1000;

    // Add time for words above threshold
    if (totalWords > APP_CONFIG.RESULTS_WORD_THRESHOLD) {
      const extraWords = totalWords - APP_CONFIG.RESULTS_WORD_THRESHOLD;
      duration += extraWords * APP_CONFIG.RESULTS_MS_PER_WORD;
    }

    return duration;
  }, []);

  const getCtaDuration = useCallback((): number => {
    return APP_CONFIG.RESULTS_CTA_DURATION * 1000;
  }, []);

  const shouldShowCta = useCallback((questionIndex: number): boolean => {
    return questionIndex > 0 && questionIndex % (APP_CONFIG.RESULTS_CTA_INTERVAL - 1) === 0;
  }, []);

  return {
    calculateSlideDuration,
    getCtaDuration,
    shouldShowCta,
  };
}
